import React from 'react';
import FormatNumber from '../../../../../components/FormatNumber';
import { connect } from 'react-redux';

function Amount(props) {
    const { statement } = props; // redux
    const { amount, currencySymbol } = props; // parent (with override currencySymbol)
    const {currency_symbol} = statement;

    const parsedCurrencySymbol = currencySymbol || currency_symbol;
    return (
        <div className="amount-container">
            <div className="currency">{parsedCurrencySymbol}</div>
            <div className="value" style={{width: 120}}>
                <FormatNumber amount={amount} />
            </div>
        </div>
    );
}

export default connect(state => ({
    statement: state.Contact.statement,
}))(Amount);
